module.exports = __webpack_public_path__ + "img/credit_red_danger_icon.803d426f.svg";